import AdDetail from './AdDetail/AdDetail';
import AdsList from './AdsList/AdsList';
import AdPost from './AdPost/AdPost';
import AdsAll from './AdsAll/AdsAll'
import AdSearch from './AdSearch/AdSearch';
import Category from './Category/Category';
// import CategoryPage from './CategoryPage/CategoryPage';
import Footer from './Footer/Footer';
import PageNotFound from './PageNotFound';
import LatestProduct from './LatestProduct/LatestProduct';
import SubCategory from './SubCategory/SubCategory';
import Navigation from './Navigation/Navigation';
// import Slider from './Slider/Slider';s


export {
    AdDetail,
    AdsList,
    AdPost,
    AdSearch,
    Category,
    AdsAll,
    // CategoryPage,
    Footer,
    LatestProduct,
    Navigation,
    SubCategory,
    PageNotFound,
    // Slider,
}


// WEBPACK FOOTER //
// ./src/components/index.js